export const COMPANY_CATEGORIES = [
  "Client",
  "Agency",
  "AOR",
  "Kinetic",
  "Matrix",
];

export const isValidCompanyCategory = (category) =>
  COMPANY_CATEGORIES.includes(category);
